import React from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import './MediaLibraryHorizatal.scss';
import {Files} from '../../../FW/Models/File';
import Loading from '../../../CommonElements/Loading';
import moment from 'moment';
import AddToCartButton from '../../../Store/AddToCartButton';

const Arrow = ({ text, className, color }) => {
  return <div
    className={className}
    style={{padding: 10, cursor: 'pointer', color}}
  >{text}</div>;
};

class MediaLibraryHorizontal extends React.Component {
  constructor(props) {
    super(...arguments);

    let library = FW.store.get('section-' + this.props.section.get('id') + '-library');
    const files = new Files();
    this.state = {
      files: files,
      loading: true
    };
    this.state.files.addQuery({
      media_libraries: [library.get('id')]
    });
    let orderBy = this.props.section.prop('options') ? this.props.section.prop('options').sort_by || 'display_date' : 'display_date';
    let orderDir = this.props.section.prop('options') ? this.props.section.prop('options').sort_direction || 'DESC' : 'DESC';
    this.state.files.sortByField(orderBy, orderDir);
    //this.state.files.setPageSize(pageSize);
    this.state.files.fetch({excludeRelations: false}).then((f) => {
      this.setState({loading: false});
    });
  }

  render() {

    if (this.state.loading) {
      return <div style={{padding: 30}}>
        <Loading wheel />
      </div>;
    }

    const arrowRightClass = this.state.loadingMore ? 'arrow-next fa fa-spinner fa-spin' : 'arrow-next fa fa-arrow-right';

    const ArrowLeft = Arrow({ text: '', className: 'arrow-prev fa fa-arrow-left', color: this.props.section.ls('arrow-color') || '#000' });
    const ArrowRight = Arrow({ text: '', className: arrowRightClass, color: this.props.section.ls('arrow-color') || '#000', loadingMore: this.state.loadingMode });

    const section = this.props.section;
    let items = this.state.files.map((item, i) => {
      const url = '/file/' + item.get('id');
      const displayDate = moment(item.get('display_date')).format('MMM Do, YYYY');
      let userOwned = FW.store.get('user') && FW.store.get('user').get('purchased_files').indexOf(item.get('id')) >= 0;
      return <div key={`feed-item-${i}`} style={{paddingLeft: 5, paddingRight: 5}}>
        <div className="well feed-item">
          {section.prop('show_thumbnails') ? <a href={url} target={section.prop('open_in_new_tab') ? '_blank' : null}>
            {section.prop('contain_image') ? <div style={{height: 121, backgroundImage: 'url(' + item.helper.featuredUrl(800) + ')', backgroundSize: 'cover'}}></div> : <img src={item.helper.featuredUrl(800)} />}
          </a> : null}
          <h5>
            <a href={url} target={section.prop('open_in_new_tab') ? '_blank' : null} style={{textOverflow: 'ellipsis', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap'}}>{item.get('title')}</a>
          </h5>
          {section.prop('show_subtitle') ? <h6><span style={{textOverflow: 'ellipsis', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap'}}>{item.get('subtitle')}</span></h6> : null}
          {!section.prop('hide_dates') ? <span style={{marginBottom: 5}}>{displayDate}</span> : null}
          {section.prop('show_description') ? <div style={{height: '3.6em'}}>
            <div className="block-with-text" dangerouslySetInnerHTML={{__html: item.get('description')}}></div>
          </div> : null}
          <br style={{width: '100%', clear: 'both'}} />
          {item.get('visibility') === 'private' ? <AddToCartButton
            noAbsolute
            title={item.get('title')}
            price={item.get('price')}
            id={item.get('id')}
            type="file"
            image={item.helper.featuredUrl(800)}
            owned={userOwned}
          /> : null}
        </div>
      </div>;
    });

    return <div className="fw-media-horizontal-section">
      <ScrollMenu
        data={items}
        arrowLeft={ArrowLeft}
        arrowRight={ArrowRight}
        alignCenter={false}
        wheel={false}
        hideSingleArrow={true}
        hideArrows={true}
        onLastItemVisible={() => {
          if (!this.state.loadingMore && this.state.files.pagination && this.state.files.pagination.number < this.state.files.pagination.last) {
            this.setState({
              loadingMore: true
            }, () => {
              this.state.files.loadMore().then(() => {
                this.setState({loadingMore: false});
              });
            });
          }
        }}
      />
    </div>;
  }
}

export default MediaLibraryHorizontal;
